import cx from 'classnames';
import SVG from 'react-inlinesvg';
import chevronLeft from 'assets/icons/chevron_left.svg';

export type SecondaryPanelHeaderProps = {
  title: string;
  isBackButtonShown: boolean;
  isNameShown: boolean;
  name: string;
  onCancel: VoidFunction;
};

export const SecondaryPanelHeader = ({
  title,
  isBackButtonShown,
  isNameShown,
  name,
  onCancel,
}: SecondaryPanelHeaderProps): React.ReactElement => (
  <div
    data-test-id="planner-secondary-panel-header"
    className={cx('flex w-full justify-between items-center border-gray-200 px-3', {
      'border-b py-3': !!title,
    })}
  >
    {!!title && (
      <div
        data-test-id="planner-secondary-panel-title"
        className="flex items-center justify-between gap-x-1 body-base font-semibold"
      >
        {isBackButtonShown && (
          <button type="button" data-test-id="planner-secondary-panel-back" onClick={onCancel}>
            <SVG src={chevronLeft} />
          </button>
        )}
        {title}
      </div>
    )}
    {isNameShown && (
      <p
        data-test-id="planner-secondary-panel-value"
        className="w-32 body-base whitespace-nowrap overflow-hidden text-ellipsis text-right text-essential-tertiary"
      >
        {name}
      </p>
    )}
  </div>
);
